import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import sustainabilityService from "./sustainabilityService";
import { setServerError } from "../error500/error500Slice";

const initialState = {
  sustainability: [],
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

export const getAllSustainabilities = createAsyncThunk(
  "sustainability/getAllSustainabilities",
  async (_, thunkApi) => {
    try {
      return await sustainabilityService.getAllSustainabilities();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      if (
        error.response &&
        (error.response.status === 500 || error.response.status === 503)
      ) {
        thunkApi.dispatch(setServerError(true));
      }

      return thunkApi.rejectWithValue(message);
    }
  }
);

export const sustainabilitySlice = createSlice({
  name: "sustainability",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllSustainabilities.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getAllSustainabilities.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.sustainability = action.payload;
      });
  },
});

export const { reset } = sustainabilitySlice.actions;
export default sustainabilitySlice.reducer;
